// Lazy loading images with Intersection Observer
function setupLazyImages() {
  // Select all images with data-src attribute
  const lazyImages = document.querySelectorAll('img[data-src]');
  
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          const dataSrc = img.getAttribute('data-src');
          
          // Handle picture element with WebP source
          if (img.parentNode.tagName.toLowerCase() === 'picture') {
            const source = img.parentNode.querySelector('source[data-srcset]');
            if (source) {
              source.srcset = source.getAttribute('data-srcset');
              source.removeAttribute('data-srcset');
            }
          }
          
          // Set the img src attribute
          img.src = dataSrc;
          img.removeAttribute('data-src');
          
          // Stop observing this image
          observer.unobserve(img);
        }
      });
    }, {
      rootMargin: '100px 0px',
      threshold: 0.01
    });
    
    // Start observing each image
    lazyImages.forEach(img => {
      imageObserver.observe(img);
    });
  } else {
    // Fallback for browsers without IntersectionObserver
    lazyImages.forEach(img => {
      // Handle picture element with WebP source for fallback
      if (img.parentNode.tagName.toLowerCase() === 'picture') {
        const source = img.parentNode.querySelector('source[data-srcset]');
        if (source) {
          source.srcset = source.getAttribute('data-srcset');
          source.removeAttribute('data-srcset');
        }
      }
      
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
    });
  }
}

// Run when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', setupLazyImages);